import { render, staticRenderFns } from "./HandlePro.vue?vue&type=template&id=9ff717a6&scoped=true&slot-scope=scope&"
import script from "./HandlePro.vue?vue&type=script&lang=js&"
export * from "./HandlePro.vue?vue&type=script&lang=js&"
import style0 from "./HandlePro.vue?vue&type=style&index=0&id=9ff717a6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff717a6",
  null
  
)

export default component.exports